/* unplugin-vue-components disabled */import { render } from "./UserInfo.vue?vue&type=template&id=4df17cf8&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"

import "./UserInfo.vue?vue&type=style&index=0&id=4df17cf8&lang=scss&scoped=true"

import exportComponent from "/var/workhome/jenkins/jenkins_home/workspace/prod-vue-mt-comp-sso/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df17cf8"]])

export default __exports__